/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SignUpResponseDto
 */
export interface SignUpResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SignUpResponseDto
     */
    id: string;
}

export function SignUpResponseDtoFromJSON(json: any): SignUpResponseDto {
    return SignUpResponseDtoFromJSONTyped(json, false);
}

export function SignUpResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignUpResponseDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function SignUpResponseDtoToJSON(value?: SignUpResponseDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

